import { render, staticRenderFns } from "./submitWork.vue?vue&type=template&id=b850c94e&scoped=true&"
import script from "./submitWork.vue?vue&type=script&lang=js&"
export * from "./submitWork.vue?vue&type=script&lang=js&"
import style0 from "./submitWork.vue?vue&type=style&index=0&id=b850c94e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850c94e",
  null
  
)

export default component.exports